import React, { useState, useEffect } from 'react';
import { Modal, Row } from 'react-bootstrap';
import { Button } from "reactstrap";
import axiosConn from 'config/axiosConn';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import CryptoJS from "crypto-js";

import { useSelector } from "react-redux";
import { userLoggedOut } from "../../redux/auth/authSlice";
import { useDispatch } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";


import { useLoginMutation } from "../../redux/auth/authApi";
import { isCaptchaRelaxed } from "utils/captchaDemo";
const generateToken = () => {
    const timestamp = Date.now();
    const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
    const token = CryptoJS.AES.encrypt(`${timestamp}`, secret).toString();
    return token;
};

// Token validation function
const validateResponseToken = (responseToken, requestToken) => {
    //   alert("token is validations")
    console.log("crazy stuff is happening")
    try {
        const secret = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
        const decrypted = CryptoJS.AES.decrypt(responseToken, secret).toString(CryptoJS.enc.Utf8);
        const timestamp = parseInt(decrypted);

        // Check if token is tampered with
        if (isNaN(timestamp)) {
            return false;
        }

        // Check if token is expired (50 seconds)
        const currentTime = Date.now();
        const timeDifference = currentTime - timestamp;
        console.log(timeDifference, "timeDifference crazy stuff is happening")
        return timeDifference <= 50000 && responseToken === requestToken;
    } catch (error) {
        return false;
    }
};



function SchoolLoginModel({ handleViewexit }) {
    const dispatch = useDispatch();
    const userData = useSelector(state => state.auth.user);
    const navigate = useNavigate();
    const [show, setShow] = useState(true);
    const [udise_id, setUsername] = useState('');
    const [login, { isSuccess, error }] = useLoginMutation();
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [operator, setOperator] = useState('+');
    const [userInput, setUserInput] = useState('');
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false); // Loading state for OTP
    const [otpSent, setOtpSent] = useState(false); // Track if OTP has been sent
    const [otpSent2, setOtpSent2] = useState(false); // Track if OTP has been sent
    const [captcha, setCaptcha] = useState("");
    const [captchaAnswer, setCaptchaAnswer] = useState("");
    const CAPTCHA_LENGTH = 6;
    const [timer, setTimer] = useState(0); // Timer state
    const [requiresPassword, setRequiresPassword] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [showSubmit, setShowSubmit] = useState(false);
    const isCaptchaError = (message = '') => /captcha/i.test(message);
    const sanitizeCaptchaInput = (value) => value.replace(/[^A-Za-z0-9]/g, "").slice(0, CAPTCHA_LENGTH);
    const sanitizeUdise = (value) => value.replace(/[^A-Za-z0-9]/g, "").slice(0, 11);


    const renderCaptcha = (captchaObj) => (
        <img src={captchaObj?.image} alt="captcha" style={{ height: '50px', borderRadius: '6px' }} />
    );

    const generateCaptcha = async () => {
        try {
            const response = await axiosConn('get', 'captcha');
            setCaptcha(response?.data?.captcha || {});
            setCaptchaAnswer("");
        } catch (error) {
            toast.error("Failed to load CAPTCHA");
        }
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const Logout = async () => {
        try {
            const makeLogout = await fetch(
                `https://ecoclubs.education.gov.in/api/logout`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                }
            );
            if (makeLogout.ok) {
                //  toast.success("Logout Successfully");
            }
        } catch (error) {
            toast.error("Logout Failed");
            console.log(error);
        }
        dispatch(userLoggedOut());
    };



    const handleLogin = async (e) => {
        e.preventDefault();
        if (!isCaptchaRelaxed() && (!captcha || !captchaAnswer || captchaAnswer.length < CAPTCHA_LENGTH)) {
            toast.error('Please complete the CAPTCHA');
            return;
        }
        try {
            let captchaId = captcha?.captchaId;
            const authToken = generateToken();
            let postData = { udise_id, activation_code: password, role: 2, activation_token: token, captchaId, captchaAnswer, authToken, isPassword: requiresPassword };
            const result = await login(postData);

            // Check if result has error or data is missing
            if (result?.error || !result?.data) {
                const message = result?.error?.data?.message || "An error occurred while logging in. Please try again.";
                toast.error(message);
                generateCaptcha();
                setCaptchaAnswer('');
                if (!isCaptchaError(message)) {
                    setPassword('');
                    setUsername('');
                    setOtpSent(false);
                    setShowCaptcha(false);
                }
                return;
            }

            if (!validateResponseToken(result.data.authToken, authToken)) {
                throw new Error('Invalid or expired token in response');
            }

            if (result.data.success) {
                toast.success("Logged in successfully!");
                setShow(false);
                handleViewexit();

                // Redirect based on requiresPassword
                if (!requiresPassword) {
                    navigate("/school/password");
                } else {
                    navigate("/school");
                }

                setPassword('');
                setUsername('');
                setCaptchaAnswer('');
                setOtpSent(false);
            }
            else {
                const message = result?.data?.message || "Login failed. Please try again.";
                toast.error(message);
                generateCaptcha();
                setCaptchaAnswer('');
                if (!isCaptchaError(message)) {
                    setPassword('');
                    setUsername('');
                    setShowCaptcha(false);
                    setOtpSent(false);
                    await Logout();
                }
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.data?.message || error?.message || "Login failed. Please try again.";
            toast.error(errorMessage);
            generateCaptcha();
            console.error("Login error:", error);
            setCaptchaAnswer('');
            if (!isCaptchaError(errorMessage)) {
                setPassword('');
                await Logout();
                setUsername('');
                setShowCaptcha(false);
                setOtpSent(false);
            }
        }
    };
    // useEffect(() => {
    //     console.log(isSuccess, error);
    //     if (isSuccess && !error) {

    //       toast.success("Logged in successfully!");

    //     setShow(false);
    //     handleViewexit();
    //     navigate("/school");
    //     }
    //     if (error) {
    //         // console.log(error)
    //         // toast.error(error.data.message)
    //       if ("data" in error) {
    //         const errorData = error ;
    //         toast.error(errorData.data.message);
    //         fetchCaptcha();
    //       }
    //     }
    //   }, [isSuccess, error]);

    // Function to start the timer
    const startTimer = (duration) => {
        setTimer(duration); // Set timer to the specified duration
        const interval = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 1) {
                    clearInterval(interval); // Stop the timer when it reaches 0
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);
    };

    const sendOTP = async (e) => {
        e.preventDefault();
        setRequiresPassword(false);
        setOtpSent(false);
        if (udise_id.length < 1) {
            toast.error("Please enter UDISE code");
            return;
        }
        else if (udise_id.length !== 11) {
            setLoading(false);
            toast.error("Please enter a valid UDISE code.");
            return;
        }
        setLoading(true);

        try {
            let postData = { udise_id, role: 2 };
            let response = await axiosConn('post', "get-otp", postData);
            setLoading(false);

            if (response.data.success) {
                if (response.data.requiresPassword) {
                    setRequiresPassword(true);
                    setOtpSent(true);
                    generateCaptcha();
                    setShowCaptcha(true);
                    setShowSubmit(true);
                    return;
                }

                const maskedEmail = (response.data.schEmail);
                const maskedMobile = (response.data.schMobile);
                toast.success(`OTP sent successfully to ${maskedEmail} & ${maskedMobile}!`);
                setToken(response.data.activationToken);
                setOtpSent(true);
                generateCaptcha();
                setOtpSent2(true);
                setShowCaptcha(true);
                setShowSubmit(true);
                startTimer(300);
            } else {
                toast.error("UDISE code incorrect. Please check the entered code.");
            }
        } catch (error) {
            setLoading(false);
            const errorMessage = error?.response?.data?.message || error?.message || "An error occurred while sending OTP. Please try again.";
            toast.error(errorMessage);
            console.error("Error sending OTP:", error);
        }
    };
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    const handleForgotPassword = async () => {

        try {
            const response = await axiosConn('get', `forgot-password?udise_id=${udise_id}`);
            if (response.data.success) {
                toast.success('OTP sent to your registered mobile number');
                setRequiresPassword(false); // Show OTP field instead of password
                setOtpSent(true);
                setToken(response.data.activationToken);
                setShowCaptcha(true);
                setShowSubmit(true);
                startTimer(300);
            } else {
                toast.error(response.data.message || 'Failed to send OTP. Please try again.');

            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to send OTP. Please try again.';
            toast.error(errorMessage);
            console.error("Forgot password error:", error);
        }
    };

    return (
        <Modal show={show} onHide={() => { setShow(false); handleViewexit(); }} className='loginmodal' enforceFocus={false}>
            <Modal.Body>
                <div className="popup-login-signup">
                    <div className="login-box">
                        <h3 className='text-center'>SCHOOL LOGIN</h3>
                        <button type="button" className='popup-close-btn' onClick={() => { setShow(false); handleViewexit(); }} >X</button>
                        <form onSubmit={handleLogin}>
                            <div className="d-flex justify-content-between align-items-end">
                                <div className="form-group mt-3" style={{ width: 'calc(100% - 120px)' }}>
                                    <label htmlFor="udise_id" className="label-text">UDISE Code</label>
                                    <input
                                        autocomplete="off"
                                        name="udise_id"
                                        type="text"  // Change to text for better control over input handling
                                        className="form-input form-control udise_id"
                                        placeholder="UDISE Code"
                                        value={udise_id}
                                        onChange={(e) => {
                                            const value = sanitizeUdise(e.target.value);
                                            setUsername(value);
                                        }}
                                        required
                                        inputMode="numeric" // Brings up a numeric keyboard on mobile devices
                                        maxLength={11}  // Restrict to a maximum of 11 characters
                                    />
                                </div>

                                <button
                                    style={{ maxWidth: '150px', borderRadius: "20px", left: "10px", bottom: "5px" }}
                                    type="button"
                                    className={`loginBtnnewhm mt-3 btn-sm mx-0 ${timer > 0 ? 'disabled' : ''}`}
                                    onClick={sendOTP}
                                    disabled={loading || timer > 0}
                                >
                                    {loading ? 'Sending...' : (otpSent2 ? (timer > 0 ? `Resend in ${formatTime(timer)}s` : 'Resend OTP') : 'Continue')}
                                </button>
                            </div>
                            {otpSent && requiresPassword && (
                                <>
                                    <div className="form-group mt-3" style={{ position: "relative" }}>
                                        <label htmlFor="password" className="label-text">Enter Your Password</label>
                                        <input
                                            autocomplete="off"
                                            name="password"
                                            type={showPassword ? "text" : "password"}
                                            className="form-input form-control"
                                            placeholder="Enter your password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value.slice(0, 64))}
                                            maxLength={64}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: '15px',
                                                bottom: '10px',
                                                cursor: 'pointer',
                                                zIndex: 10
                                            }}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                    <div style={{
                                        fontSize: '12px',
                                        marginTop: '10px',
                                        textAlign: 'right'
                                    }}>
                                        <span style={{
                                            color: '#007bff',
                                            cursor: 'pointer',
                                            textDecoration: 'underline'
                                        }} onClick={handleForgotPassword}>Forgot Password</span>
                                    </div>

                                </>
                            )}
                            {otpSent && !requiresPassword && (

                                <div className="form-group mt-3">
                                    <label htmlFor="password" className="label-text">Enter The OTP Received</label>
                                    <input
                                        autocomplete="off"
                                        name="password"
                                        type="text"
                                        required
                                        placeholder="Enter Your OTP"
                                        className="form-input form-control"
                                        value={password}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                            if (value.length <= 4) {
                                                setPassword(value);
                                            }
                                        }}
                                        maxLength={4}
                                        inputMode="numeric"
                                    />
                                </div>

                            )}
                            {showCaptcha && (
                                <div className="form-group mt-3">
                                    <div className="captcha-container">
                                        {renderCaptcha(captcha)}
                                        <div className="captcha-controls">
                                            <input
                                                type="text"
                                                value={captchaAnswer}
                                                onChange={(e) => setCaptchaAnswer(sanitizeCaptchaInput(e.target.value))}
                                                placeholder="Enter the code"
                                                maxLength={CAPTCHA_LENGTH}
                                                autoComplete="off"
                                            />
                                            <button
                                                type="button"
                                                className="captcha-refresh"
                                                onClick={generateCaptcha}
                                                title="Refresh CAPTCHA"
                                            >
                                                ↻
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {showSubmit && (
                                <div className="form-group mt-3">
                                    <Button type="submit" className="button green btn-login-signup">
                                        Submit
                                    </Button>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default SchoolLoginModel;
